// Shared nav config + motion constants
export const NAV_ITEMS = [
  { labelKey: 'home', id: 'home' },
  { labelKey: 'about', id: 'about' },
  { labelKey: 'services', id: 'services' },
  { labelKey: 'blog', id: 'blog' },
  { labelKey: 'contact', id: 'contact' },
];

export const NAV_INITIAL = { y: -100 };
export const NAV_ANIMATE = { y: 0 };

export const NAV_LINK_HOVER = { y: -2, scale: 1.02 };
export const LANG_BUTTON_HOVER = { scale: 1.1 };
export const LANG_BUTTON_TAP = { scale: 0.95 };
export const CTA_BUTTON_HOVER = { scale: 1.05 };
export const CTA_BUTTON_TAP = { scale: 0.95 };

export const MOBILE_MENU_INITIAL = { height: 0 };
export const MOBILE_MENU_OPEN = { height: 'auto' };
export const MOBILE_MENU_CLOSED = { height: 0 };

export const NAV_LINK_STYLE = { textShadow: '0 0 0px rgba(255, 107, 53, 0)' };

export const handleNavLinkMouseEnter = (e) => {
  e.currentTarget.style.textShadow = '0 0 12px rgba(255, 107, 53, 0.6), 0 0 20px rgba(78, 205, 196, 0.4)';
};

export const handleNavLinkMouseLeave = (e) => {
  e.currentTarget.style.textShadow = '0 0 0px rgba(255, 107, 53, 0)';
};
